function getConfig(name, defaultValue=null) {
    // If inside a docker container, use window.ENV
    if( window.ENV !== undefined ) {
        return window.ENV[name] || defaultValue;
    }

    return process.env[name] || defaultValue;
}

export function getBackendUrl() {
	var bDir = window.location.host.split('.');
		var newUrl = window.location.protocol + "//" + bDir[0] + "back";
		for (var i = 1; i < bDir.length; i++) { 
		  newUrl += "." + bDir[i];
		}
    //return getConfig('REACT_APP_BACKEND_URL');
	return newUrl;
}

export function getHoursCloseTicketsAuto() {
    return getConfig('REACT_APP_HOURS_CLOSE_TICKETS_AUTO');
}